import { ComponentPropsWithoutRef, MouseEvent, useState } from "react";

import { Check } from "@hl/base-components/lib/assets/icons.generated";
import { ColorSchemeMode } from "@hl/base-components/lib/theme/ColorSchemeContext";
import {
  OUTLINE_COLOR,
  SECONDARY_COLOR,
} from "@hl/base-components/lib/theme/button";
import { Button, ButtonProps, useMantineTheme } from "@mantine/core";
import { useTimeout } from "@mantine/hooks";

import { useCreateCollectionFormContext } from "~/features/collections/forms/CreateCollectionMultistepForm/context";

type SaveDraftButtonProps = ButtonProps & ComponentPropsWithoutRef<"button">;

const SaveDraftButton = ({
  size = "lg",
  type = "submit",
  onClick,
  ...rest
}: SaveDraftButtonProps) => {
  const [isSaved, setIsSaved] = useState(false);
  const theme = useMantineTheme();
  const { start } = useTimeout(() => setIsSaved(false), 2000);

  const form = useCreateCollectionFormContext();

  return (
    <Button
      size={size}
      type={type}
      color={
        theme.colorScheme === ColorSchemeMode.LIGHT
          ? SECONDARY_COLOR
          : OUTLINE_COLOR
      }
      px={12}
      disabled={!form.isDirty()}
      onClick={(e: MouseEvent<HTMLButtonElement>) => {
        setIsSaved(true);
        start();
        onClick?.(e);
      }}
      {...rest}
    >
      {isSaved ? (
        <>
          <Check /> Saved
        </>
      ) : (
        "Save draft"
      )}
    </Button>
  );
};

export default SaveDraftButton;
